import { getCurrentUser } from 'domains/current_user';
import ky from 'ky';
import { Vehicle } from 'types';
import DEFAULT_OPTION from 'domains/api/default_option';

type VehiclesResponse = {
  vehicles: Vehicle[];
};
type VehicleResponse = {
  vehicle: Vehicle;
};
type EmptyResponse = Record<string, never>;

export const getVehicles = async (): Promise<VehiclesResponse> => {
  const currentUser = getCurrentUser();

  const options = {
    ...DEFAULT_OPTION,
    headers: {
      'access-token': currentUser?.accessToken,
      client: currentUser?.client,
      uid: currentUser?.uid,
    },
    throwHttpErrors: true,
  };

  const response = await ky.get('fuel_consumption/vehicles', options);

  return response.json();
};

export const getVehicle = async (id: number): Promise<VehicleResponse> => {
  const currentUser = getCurrentUser();

  const options = {
    ...DEFAULT_OPTION,
    headers: {
      'access-token': currentUser?.accessToken,
      client: currentUser?.client,
      uid: currentUser?.uid,
    },
    throwHttpErrors: true,
  };

  const response = await ky.get(`fuel_consumption/vehicles/${id}`, options);

  return response.json();
};

export const postVehicle = async (
  vehicle: Vehicle,
): Promise<VehicleResponse> => {
  const currentUser = getCurrentUser();

  const options = {
    ...DEFAULT_OPTION,
    headers: {
      'access-token': currentUser?.accessToken,
      client: currentUser?.client,
      uid: currentUser?.uid,
    },
    json: { vehicle },
    throwHttpErrors: true,
  };

  const response = await ky.post('fuel_consumption/vehicles', options);

  return response.json();
};

export const patchVehicle = async (
  vehicle: Vehicle,
): Promise<VehicleResponse> => {
  const currentUser = getCurrentUser();

  const options = {
    ...DEFAULT_OPTION,
    headers: {
      'access-token': currentUser?.accessToken,
      client: currentUser?.client,
      uid: currentUser?.uid,
    },
    json: { vehicle },
    throwHttpErrors: true,
  };

  const response = await ky.patch(
    `fuel_consumption/vehicles/${vehicle.id}`,
    options,
  );

  return response.json();
};

export const deleteVehicles = async (
  vehicle: Vehicle,
): Promise<EmptyResponse> => {
  const currentUser = getCurrentUser();

  const options = {
    ...DEFAULT_OPTION,
    headers: {
      'access-token': currentUser?.accessToken,
      client: currentUser?.client,
      uid: currentUser?.uid,
    },
    throwHttpErrors: true,
  };

  const response = await ky.delete(
    `fuel_consumption/vehicles/${vehicle.id}`,
    options,
  );

  return response.json();
};
